/* eslint-disable no-undef */
export default () => {
  // listener for size variant selector
  document.querySelectorAll('[data-size-variant-selector]').forEach((element) => {
    element.addEventListener('click', (e) => {
      const option = e.currentTarget;
      (rtbhEvents = window.rtbhEvents || []).push(
        {
          eventType: 'size',
          size: option.getAttribute('data-value'),
        },
        {
          eventType: 'uid',
          id: window.theme.rtb_uid,
        },
      );
    });
  });

  // listener for rtb_availability event
  document.addEventListener('rtb_availability', () => {
    (rtbhEvents = window.rtbhEvents || []).push(
      {
        eventType: 'offlinecheck',
      },
      {
        eventType: 'uid',
        id: window.theme.rtb_uid,
      },
    );
  });

  // listener add to cart button
  document.addEventListener('rtb_add_to_cart', (e) => {
    const variant_id = e.detail;
    
    if (!variant_id) {
      return;
    }
    
    window.rtbhEvents = window.rtbhEvents || [];
    
    window.rtbhEvents.push({
      eventType: 'basketadd',
      offerId: `${variant_id}`,
    }, {
      eventType: 'uid',
      id: window.theme.rtb_uid,
    });
  });
};